import { Box, Card, CardContent, Chip, Stack, Typography } from "@mui/material";
import { allColors } from "../../constants";

const ServiceCard = ({ icon, title, description, services }) => {
    const scrollingServices = [...services, ...services];
    const animationDuration = `${Math.max(services.length * 3, 12)}s`;

    const styles = {
        card: {
            boxShadow: "none",
            borderRadius: "30px",
            border: "1px solid #EAEAEA",
            padding: { xs: 1, sm: 1.5, md: 2.5, lg: 3 },

        },
    }
    return (
        <Card
            sx={styles.card}
        >
            <Box
                component={"img"}
                src={icon}
                alt={title}
                width={50}
                height={50}
                mb={2.5}
            />
            <CardContent sx={{ padding: "0px", "&:last-child": { paddingBottom: "0px" } }}>
                <Typography variant="h5" fontWeight="600" color={allColors.black} fontSize={{ xs: "20px", md: "25px" }} mb={1}>{title}</Typography>
                <Typography variant="body2" >{description}</Typography>
                <Box
                    mt={2.5}
                    sx={{
                        overflow: "hidden",
                        position: "relative",
                        "@keyframes serviceMarquee": {
                            "0%": { transform: "translateX(0)" },
                            "100%": { transform: "translateX(-50%)" },
                        },
                    }}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        gap={1}
                        sx={{
                            width: "max-content",
                            whiteSpace: "nowrap",
                            animation: `serviceMarquee ${animationDuration} linear infinite`,
                        }}
                    >
                        {scrollingServices.map((service, index) => (
                            <Chip variant="outlined" key={`${service}-${index}`} label={service} />
                        ))}
                    </Stack>
                </Box>
            </CardContent>
        </Card>
    )
}

export default ServiceCard;